import { PWA_SESSION_KEY, formatISODate } from 'shared';
export function readPwaSession() {
    const raw = sessionStorage.getItem(PWA_SESSION_KEY);
    if (!raw)
        return null;
    try {
        return JSON.parse(raw);
    }
    catch {
        sessionStorage.removeItem(PWA_SESSION_KEY);
        return null;
    }
}
export function writePwaSession(patch) {
    const existing = readPwaSession() ?? {};
    sessionStorage.setItem(PWA_SESSION_KEY, JSON.stringify({ ...existing, ...patch }));
}
export function resolveServiceDate(category) {
    if (category === 'today_or_past')
        return formatISODate(new Date());
    if (category === 'within_30_days') {
        const d = new Date();
        d.setDate(d.getDate() + 30);
        return formatISODate(d);
    }
    return undefined;
}
export function clearPwaSession() {
    sessionStorage.removeItem(PWA_SESSION_KEY);
}
export function resetPwaSessionToEntry() {
    const session = readPwaSession();
    if (!session)
        return;
    sessionStorage.setItem(PWA_SESSION_KEY, JSON.stringify({
        channel: session.channel,
        locationId: session.locationId,
        selectedLocation: session.selectedLocation,
    }));
}
